import { AbortError } from '../AbortError';
import { isDomException } from './isDomException';
import { isNativeError } from './isNativeError';

// Проверяет, что ошибка является инстансом нативного или структурированного AbortError
export function isAbortError(err: unknown): err is Error {
    // DOMException проверяем отдельно: `AbortSignal.abort().reason` — именно он,
    // а isNativeError не признает DOMException из другого realm.
    return err instanceof AbortError || ((isNativeError(err) || isDomException(err)) && err.name === 'AbortError');
}
